import { make } from "vuex-pathify";
import { getAPI, postAPI } from "@/store/restAPI.js";//eslint-disable-line
import { getDownloadAPI } from "@/store/restAPI.js";


// initial state
const state = {
    loading: false,
};

// getters
const getters = {};

// actions
const actions = {

  deleteOrder({ commit } , id) {
    commit("SET_LOADING", true);
    return postAPI("order/deleteOrder/" + id).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },
  
  retrieveOrders({ commit } ,  filter) {
    commit("SET_LOADING", true);
    return getAPI("order/retrieveOrders" , filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveOrdersBySearch({ commit } , filter) {
    commit("SET_LOADING", true);
    return getAPI("order/retrieveOrdersBySearch" , filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  saveOrder({ commit }, order) {
    commit("SET_LOADING", true);
    return postAPI("order/saveOrder", order).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveById({ commit }, id) {
    commit("SET_LOADING", true);
    return getAPI("order/retrieveById" , id)
      .then((response) => {
        return response;
      })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveAllOrders({ commit } , filter){
    commit("SET_LOADING", true);
    return getAPI("order/retrieveAllOrders" , filter)
      .then((response) => {
        return response;
      })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  downloadPDF({ commit }, id) {
    commit("SET_LOADING", true);
    return getDownloadAPI("order/downloadPDF/" + id)
    .finally(() => commit("SET_LOADING", false));
  },

  exportExcelOrder({ commit } , filter) {
    commit("SET_LOADING", true);
    return getDownloadAPI("order/exportExcelOrder" , filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  showPrecinctPicture({ commit }, id) {
    commit("SET_LOADING", true);
    return getDownloadAPI("order/showPrecinctPicture/" + id)
        .then((response) => {
          return response;
        })
        .finally(function () {
          commit("SET_LOADING", false);
        });
    },

  reopenOrder({ commit }, id) {
    commit("SET_LOADING", true);
    return postAPI("order/reopenOrder/" + id)
      .then((res) => {
        return res;
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },

  toggleDispatchType({ commit }, orderId) {
    commit("SET_LOADING", true);
    return postAPI("order/toggleDispatchType/" + orderId)
      .then((res) => {
        return res;
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },

  countOrders(context, filter) {
    // Don't set loading for count operations - it's a quick query and causes double loading
    // when called together with retrieveOrders/retrieveOrdersBySearch
    return getAPI("order/count", filter).then((res) => {
      return res;
    });
  },

};

// mutations
const mutations = {
    ...make.mutations(state),
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };